import React, { useState, useEffect, Fragment } from 'react';
import "./Actualités.css"
import { useNavigate, useParams } from 'react-router-dom';
import { Card, Button } from 'react-bootstrap';
import { getATypeOfArticles } from '../../http/http';

const Actualités = () => {

    let { actualite_id } = useParams();
    const [actualiteData, setActualiteData] = useState();

    const navigate = useNavigate();

    useEffect(() => {
        loadActualiteData();
    }, [actualite_id])

    const loadActualiteData = async () => {
        const resp = await getATypeOfArticles("actualites")
        if (resp.response && resp.response.status !== 200) {
        } else {
            let element = resp.data?.data?.filter(elt => {
                if (elt.id == actualite_id) {
                    return elt
                } else {
                    return false
                }
            })
            setActualiteData(element)
        }
    }


    return (
        <div>

            <div style={{ background: '#FFF' }}>
                <h2 style={{ 'color': '#4385F6', 'padding-top': '70px' }}>{actualiteData && actualiteData[0].title}</h2>
                <Card className={'law-card'}>
                    <Card.Body className='d-flex flex-wrap'>
                        <Card.Img className='m-auto' src={actualiteData && actualiteData[0]?.image_url} />
                        <Card.Text>
                            <div className='ql-editor' dangerouslySetInnerHTML={{ __html: (actualiteData && actualiteData[0]?.content) }}></div>
                        </Card.Text>

                    </Card.Body>
                </Card>

                <br />

                <button className='back-button' onClick={() => navigate("/")}>Retour</button>

            </div>
        </div>
    )
}

export default Actualités